import {defineStore} from 'pinia'
import {ref} from 'vue'
import {useTapApi} from '../composables/useTapApi'

export const TARIFF_SETTINGS_HINT = 'list_marker'

export const useTariffSettingsHintStore = defineStore('tariff-settings-hint', () => {
  const api = useTapApi()
  const ready = ref(false)
  const viewed = ref(false)
  const dismissing = ref(false)
  const error = ref(false)
  let session = 0
  let request: Promise<void> | undefined

  const load = async () => {
    if (ready.value) return
    if (request) return request
    const startedSession = session
    const pending = (async () => {
      try {
        const response = await api.checkHintStatus(TARIFF_SETTINGS_HINT)
        if (session !== startedSession || typeof response !== 'boolean') return
        viewed.value = response
        ready.value = true
      } catch { /* Retry on the next editor opening; an unknown status stays hidden. */ }
    })()
    request = pending
    try { await pending } finally { if (request === pending) request = undefined }
  }

  const dismiss = async () => {
    if (!ready.value || viewed.value || dismissing.value) return
    const startedSession = session
    dismissing.value = true
    error.value = false
    try {
      await api.viewHint(TARIFF_SETTINGS_HINT)
      if (session === startedSession) viewed.value = true
    } catch {
      if (session === startedSession) error.value = true
    } finally { if (session === startedSession) dismissing.value = false }
  }

  const reset = () => {
    session++
    request = undefined
    ready.value = false
    viewed.value = false
    dismissing.value = false
    error.value = false
  }
  return {ready, viewed, dismissing, error, load, dismiss, reset}
})
